import { useEffect, useState } from 'react';
import { resolveNovaPostDeliveryCityRef } from '../utils/novaPostApi';

/**
 * Якщо передано cityName без готового novaPostDeliveryCityRef — резолвить DeliveryCity через API НП.
 * Інакше використовує явний novaPostDeliveryCityRef або novaPostCityRef (checkout).
 */
export function useNovaPostDeliveryCityRef({
  cityName,
  novaPostCityRef,
  novaPostDeliveryCityRef,
}) {
  const [resolvedRef, setResolvedRef] = useState('');
  const [isResolving, setIsResolving] = useState(false);
  const needsResolve = Boolean(cityName) && !novaPostDeliveryCityRef;

  useEffect(() => {
    if (!needsResolve) {
      setResolvedRef('');
      setIsResolving(false);
      return undefined;
    }

    let cancelled = false;
    setIsResolving(true);

    resolveNovaPostDeliveryCityRef(cityName, novaPostCityRef)
      .then((ref) => {
        if (!cancelled) {
          setResolvedRef(ref);
          setIsResolving(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setResolvedRef('');
          setIsResolving(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [needsResolve, cityName, novaPostCityRef]);

  const cityRef = novaPostDeliveryCityRef || (needsResolve ? resolvedRef : '') || novaPostCityRef || '';

  return { cityRef, isResolving: needsResolve && isResolving };
}
